import { render, staticRenderFns } from "./verficationEmail.vue?vue&type=template&id=9c314f12&"
import script from "./verficationEmail.vue?vue&type=script&lang=js&"
export * from "./verficationEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports